export default __webpack_public_path__ + "static/media/calendarIcon.2e2bc501.svg";